export const DEFAULT_TRACK_ROUTE = "/api/split/track";
export const DEFAULT_GET_TREATMENTS_ROUTE = "/api/split/get-treatments";
export const GENERIC_TREATMENTS_ERROR = "Could not return correct treatments";
export const GENERIC_TRACK_ERROR = "Could not send track event";
export const GENERIC_CLIENT_ERROR = "Could not initiate client";
